



















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class NewItem extends Vue {
  @Prop() placeholder!: string;
  @Prop() maxLength!: number;
  @Prop() id!: string;

  private value = '';

  onEnter(event: any) {
    this.commit(this.value);
    event.target && event.target.blur();
  }

  onEsc() {
    this.value = '';
  }

  private commit(value: string) {
    this.$emit('onCommit', value);
    this.value = '';
  }
}
